var _rect, _circle, _circle2, _path, _path2, _path3, _circle3, _rect2, _rect3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstallationChauffeEauThermoc36B5Def0D36D3630C07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 82,
    viewBox: "0 0 83 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 0.5,
    width: 56.5212,
    height: 80.68,
    rx: 7.5,
    fill: "white",
    stroke: "#08305E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 25.5,
    r: 9.25,
    fill: "white",
    stroke: "#08305E",
    strokeWidth: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5004,
    cy: 25.5,
    r: 6.90909,
    fill: "#08305E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4271 25.1998C41.6669 24.7845 49.9624 24.9121 47.704 28.8238C45.4456 32.7355 41.1873 25.6152 41.4271 25.1998Z",
    fill: "#E2F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.487 26.9904C42.0074 26.9904 37.9702 19.7424 42.487 19.7424C47.0039 19.7424 42.9666 26.9904 42.487 26.9904Z",
    fill: "#E2F0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5026 25.1998C43.2628 24.7845 34.9673 24.9121 37.2257 28.8238C39.4841 32.7355 43.7424 25.6152 43.5026 25.1998Z",
    fill: "#E2F0FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.4693,
    cy: 25.8349,
    r: 0.945386,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.1016,
    y: 55.2203,
    width: 48.3178,
    height: 19.5572,
    rx: 4,
    fill: "#E2F0FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3579,
    y: 60.9724,
    width: 13.8051,
    height: 8.05296,
    rx: 1,
    fill: "#08305E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.3052,
    cy: 65.5741,
    r: 2.30085,
    fill: "#EB475F"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.2164,
    cy: 65.5741,
    r: 2.30085,
    fill: "#EB475F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallationChauffeEauThermoc36B5Def0D36D3630C07);
export default __webpack_public_path__ + "static/media/installation_chauffe_eau_thermo.c36b5def0d36d3630c07.c36b5def0d36d3630c0788d0effaded5.svg";
export { ForwardRef as ReactComponent };